import { AccordionDetails, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material';
import React from 'react';

const Lab: React.FunctionComponent<any> = ({ handleCheck, isDisable, validationObj, disable }) => {
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions">
        <Grid md={12}>
          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Was the local lab certificate reviewed and valid?
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvcl_llab_cert"
                  value={validationObj.stdy_imvcl_llab_cert}
                  onChange={e => handleCheck(e, 'section10')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvcl_llab_cert == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvcl_llab_cert == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvcl_llab_cert_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvcl_llab_cert_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section10')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7} pr={1}>
              Has all equipment used for study-related procedures or processes been recently calibrated or maintained
              and are the records available? Details should be recorded in the ISF
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvcl_calibrate"
                  value={validationObj.stdy_imvcl_calibrate}
                  onChange={e => handleCheck(e, 'section10')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvcl_calibrate == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvcl_calibrate == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvcl_calibrate_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvcl_calibrate_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section10')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12}>
          <Grid container mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Are the local lab ranges in FICS current and accurate?
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvcl_llab_range"
                  value={validationObj.stdy_imvcl_llab_range}
                  onChange={e => handleCheck(e, 'section10')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvcl_llab_range == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvcl_llab_range == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvcl_llab_range_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvcl_llab_range_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section10')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default Lab;
